export default  {
  bindings: {
    day: '=',
    formTab: '=',
    activeDay: '&'
  },
  controller: 'dayFormController',
  template: require('../views/day.form.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/days/components/day.form.component.js